// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectCeilingQueryResult, selectCeilingsPageLoading, selectCeilingsShowInitWaitingMessage} from '../_selectors/ceiling.selectors';

export class CeilingsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectCeilingsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectCeilingsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectCeilingQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
